<template>
  <div>
    <h2 class="kojin-title" style="background-color:orange">チェックイン</h2>
  </div>
  <div class="p-4" style="margin-top:0;background-color:white">
    <!-- パンくずリスト -->
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="mypage" style="cursor:pointer">マイページ</li>
        <li class="breadcrumb-item active" aria-current="page">チェックイン</li>
      </ol>
    </nav>
    <div>
      <table border="1" rules="all" style="width:100%;border-collapse:collapse;margin-bottom:10px;border:2px solid #06F;background-color:cornsilk">
        <tr>
          <td style="max-width:100px;width:30%"><b>行動種別</b></td>
          <td v-if="jisseki.program_kbn == 1">
            体験プログラム
          </td>
          <td v-else-if="jisseki.program_kbn == 2">
            事前説明会
          </td>
          <td v-else>
            事後集会
          </td>
         </tr>
         <tr>
          <td style="max-width:100px;width:30%"><b>名称</b></td>
          
          <td v-if="jisseki.program_kbn == 1">
            {{ jisseki.taiken_no_text }}：{{ jisseki.name }}
          </td>
          <td v-else-if="jisseki.program_kbn == 2">
            {{ jisseki.jizen_name }}
          </td>
          <td v-else>
            {{ jisseki.jigo_name }}
          </td>
         </tr>
        
         <tr style="border-top:2px solid #06F">
          <td style="background-color:orange"><b>チェックイン</b></td>
          <td style="background-color:#ADE0EE;">
            <template v-if="message == 'チェックインしました。'">{{ DateTimeSetting(checkin_date) }} </template>
            <template v-else>{{ EuDateTimeSetting(checkin_date) }} </template>
            
          </td>
         </tr>
        </table>

       <span style="color:red"> {{ message }} </span>

      <div style="text-align:center;padding:6px;width: 100%;display: flex;justify-content: center;">
        <button v-on:click="mypage()" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right:10px;margin-right: 10px;display:flex;align-items: center;justify-content: center;"  >
          戻る
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */ 
import { useRouter, useRoute } from 'vue-router'
import { DateSetting,TimeSetting,DateTimeSetting,EuDateTimeSetting } from '../js/userdata.js'
import AWS from 'aws-sdk';
import { ref } from 'vue';
const router = useRouter()
const route = useRoute()
const prop = defineProps(['param'])

const jisseki = prop.param.check_jisseki
const message = prop.param.message
const checkin_date = prop.param.checkin_date
const cityname = route.params.shakyo

const emit = defineEmits(['call'])
emit('call', { cmd:'loading_end_noreload'})

//------------------- 体験プログラム一覧表示へ
const home = () => { router.push('/'+cityname+'/Taiken') }
//------------------- マイページへ
const mypage = () => { 
  emit('call', { cmd:'mypage'})
}

 

</script>
<style scoped>
</style>
